export default __webpack_public_path__ + "static/media/Asset_Header_Logo.2e34cc64.png";